import { render, staticRenderFns } from "./wasteReportManageDetail.vue?vue&type=template&id=728e7c39"
import script from "./wasteReportManageDetail.vue?vue&type=script&lang=js"
export * from "./wasteReportManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728e7c39')) {
      api.createRecord('728e7c39', component.options)
    } else {
      api.reload('728e7c39', component.options)
    }
    module.hot.accept("./wasteReportManageDetail.vue?vue&type=template&id=728e7c39", function () {
      api.rerender('728e7c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteReportManageDetail.vue"
export default component.exports